/**
 * Pre-compiled es messages for DataTable
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  comfortable: `Cómoda`,
  comfortableAriaLabel: `Sección cómoda`,
  compact: `Compacta`,
  compactAriaLabel: `Sección compacta`,
  dataTable: `Tabla de datos`,
  dataTableBody: `Cuerpo de la tabla de datos`,
  dataTableHeader: `Encabezamiento de la tabla de datos`,
  expandRows: `Extender filas`,
  fullText: `Texto completo`,
  fullTextAriaLabel: `Sección de texto completo`,
  hiddenColumns: `Columnas ocultas`,
  hiddenColumnsAriaLabel: `Lista de columnas ocultas`,
  hideColumn: `Ocultar columna`,
  layoutSettings: `Configuraciones de formato`,
  layoutSettingsAriaLabel: `Sección de configuraciones de formato`,
  noHiddenColumns: `Sin columnas ocultas`,
  pinRows: `Fijar filas`,
  reset: `Restablecer columnas`,
  resizeColumn: `Ajustar tamaño de columna`,
  rowDensity: `Densidad de filas`,
  rowDensityAriaLabel: `Sección de densidad de filas`,
  searchHiddenColumns: `Buscar...`,
  selectRow: `Seleccionar fila`,
  settings: `Configuraciones de tablas`,
  settingsTabsAriaLabel: `Pestañas de configuración`,
  textPreviews: `Vistas preliminares de texto`,
  textPreviewsAriaLabel: `Sección de vistas preliminares de texto`,
  textVisibility: `Visibilidad de texto`,
  textVisibilityAriaLabel: `Sección de visibilidad de texto`,
  visibleColumns: `Columnas visibles`,
  visibleColumnsAria: `Lista de columnas visibles`,
  visibleColumnsList: `Columnas visibles`,
};
